namespace RioERP.Web.Enums {
    export enum EYears {
        Y2024 = 2024,
        Y2025 = 2025
    }
    Serenity.Decorators.registerEnumType(EYears, 'RioERP.Web.Enums.EYears');
}
